import React from 'react';
import { LabelAndValue } from '../../../../../global/components/data-display/label-value';
import { CompensationProps } from '../../../models/arc-epi-props';
import { CalculatedTotals, ScheduledPayment } from '../compensation-history/compensation-history-model';

interface Props {
    calculatedTotals: CalculatedTotals | ScheduledPayment;
    compensationProps: CompensationProps;
}
export function CalculatedTotalsDisplay(props: Props) {
    const { calculatedTotals, compensationProps } = props;

    const emptyTotal = '$0.00';
    return (
        <>
            <LabelAndValue
                label={compensationProps.housingValueLabelDB}
                value={calculatedTotals?.calculated_housing || emptyTotal}
                tooltipMessage={compensationProps.housingValueLabelDBHelperText} />
            <LabelAndValue
                label={compensationProps.totalAssessableCompensationLabelDB}
                value={calculatedTotals?.tac || emptyTotal}
                tooltipMessage={compensationProps.totalAssessableCompensationLabelDBHelperText} />
            <LabelAndValue
                label={compensationProps.housingValueLabelDC}
                value={calculatedTotals?.calculated_housing_dc_rsvp || emptyTotal}
                tooltipMessage={compensationProps.housingValueLabelDCHelperText} />
            <LabelAndValue
                label={compensationProps.totalAssessableCompensationLabelDC}
                value={calculatedTotals?.tac_dc_rsvp || emptyTotal}
                tooltipMessage={compensationProps.totalAssessableCompensationLabelDBHelperText} />
        </>
    );
}